<template>
  <v-card>
    <v-card-text>
      <v-container container--fluid grid-list-md>
         <v-row justify="space-around" align="center">
          <!--<v-col cols="6" class="font-weight-bold">{{item.text}}</v-col>-->
          <v-col cols="12" sm="12" md="6" v-for="(item, index) in items" :key="index">
            <v-text-field

              :label="item.text"
              :readonly="readonly && ['ID', 'Name'].includes(item.text)"
              v-model="clientInfo[item.key]"
            ></v-text-field>
          </v-col>

         <v-col cols="6">
           <v-autocomplete
             :items="apiKeyItems"
             v-model="clientInfo.api_access_level"
             item-text="name"
             item-value="id"
             label="Api Access level"
           >
           </v-autocomplete>
         </v-col>

          <v-col cols="6">
            <v-switch
              label="Active"
              v-model="clientInfo.active"
              @change="activateOrDeactivate"
              style="justify-content: center"
            ></v-switch>
          </v-col>
          <v-col v-if="this.clientInfo.id > 0" cols="12" class="justify-center">
            <v-row style="flex-direction: column">
              <h3 class="mx-auto">Logo</h3>
              <v-img class="mx-auto my-4" :src="clientLogo" width="150px"></v-img>
              <v-btn text color="indigo" @click="$refs.manifest.click()">
                <div>Change Logo</div>
              </v-btn>
              <input v-show="false" ref="manifest" type="file" accept="image/*" @change="handleFileUpload">
            </v-row>


          </v-col>
         </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
  import axios from 'axios'

  // @group EditClient
  // Client Information tab for EditClientPage
  export default {
    props: {
      // Client Object
      clientInfo: Object,
      // Readonly Boolean
      readonly: Boolean,
    },
    name: "ClientInformation",
    data() {
      return {
        items: [
          {text: 'ID', key: 'id'},
          {text: 'Name', key: 'name'},
          {text: 'Address', key: 'address'},
          {text: 'Address 2', key: 'address2'},
          {text: 'Suburb', key: 'suburb'},
          {text: 'State', key: 'state'},
          {text: 'Postcode', key: 'postcode'},
          {text: 'Country', key: 'country'},
          {text: 'Phone', key: 'phone'},
          {text: 'Invoice Text', key: 'invoice_text'},
          {text: 'Email Domain', key: 'google_domain'},
        ],
        apiKeyItems : [
          {id:null, name:'None'},
          {id:'staging', name:'Staging'},
          {id:'production', name:'Production'},
        ]
      }
    },
    computed: {
      clientLogo() {
        if (this.clientInfo.logo === null || this.clientInfo.logo.length === 0) {
          return "http://bcrc.io/logo.png";
        } else {
          return this.clientInfo.logo;
        }
      }
    },
    methods: {
      // @vuese
      // Makes the calls to activate or deactivate the client depending on the previous position of the toggle
      activateOrDeactivate() {
        let suffix = '';
        if (this.clientInfo.active) {
          suffix = '/activate';
        } else {
          suffix = '/deactivate';
        }
        axios.post(process.env.API_URL + '/clients/' + this.clientInfo.id + suffix)
          .then((response) => {
            if (response.status === 400) {
            }
          })
          .catch((error) => {
            if (error.response !== undefined) {
                this.$store.commit('displaySnackbar', 'ERROR: ' + error.response.data.error);
            } else {
                this.$store.commit('displaySnackbar','ERROR: activate/deactivate failed');
            }
            this.clientInfo.active = !this.clientInfo.active;
          })
      },
      handleFileUpload() {
        let upload = new FormData();
        upload.append('logo', this.$refs.manifest.files[0]);
        axios({
          method: 'post',
          url: process.env.API_URL + '/clients/' + this.clientInfo.id + '/logo',
          data: upload,
          config: {
            headers: {
              'Content-Type':
                'multipart/form-data'
            }
          }
        })
          .then((response) => {
            if (response.status === 200) {
              this.clientInfo.logo = response.data.url;
                this.$store.commit('displaySnackbar', "New logo uploaded");
            }
            this.$emit('alert', 'ERROR: An unknown problem occurred');
          })
          .catch((error) => {
            if (error.response !== undefined) {
                this.$store.commit('displaySnackbar', 'ERROR: ' + error.response.data.error);
            } else {
                this.$store.commit('displaySnackbar', 'ERROR: An unknown problem occurred');
            }
          })
      },
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/util/Clients/ClientInformation.vue